import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Table, Input, FormGroup, Label, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import UiContent from "../../../../Components/Common/UiContent";
import BetterStandsContext from "../../../../Components/Contexts/Management/BetterStandsContext";
import DenetimFormu from '../../Forms/DenetimFormu';
import { useTranslation } from "react-i18next";
import i18n from "../../../../i18n";

const tableStyles = {
    tableResponsive: {
        overflowX: 'auto',
        width: '100%'
    },
    table: {
        width: '100%'
    },
    cell: {
        wordBreak: 'break-word',
        maxWidth: '200px'
    }
};

const Denetim = () => {
  const { t } = useTranslation("saha");
    useEffect(() => { document.title = i18n.t("saha:isgDenetim.isgStandlar"); }, []);
    const formCount = 32;
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedStand, setSelectedStand] = useState(null);
    const { 
        fetchActiveFairId, 
        fetchActiveStands, 
        activeFairId, 
        stands 
    } = useContext(BetterStandsContext);

    useEffect(() => {
        const initializePage = async () => {
            setLoading(true);
            try {
                const userId = localStorage.getItem('userId');
                if (!userId) {
                    console.error("User ID not found in localStorage");
                    return;
                }
                await fetchActiveFairId(userId);
            } catch (error) {
                console.error("Error initializing page:", error);
            } finally {
                setLoading(false);
            }
        };

        initializePage();
    }, [fetchActiveFairId]);

    useEffect(() => {
        if (activeFairId) {
            fetchActiveStands(0, 50, null, searchTerm, activeFairId);
        }
    }, [activeFairId, fetchActiveStands, searchTerm]);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredStands = stands.filter(stand =>
        stand.stand_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        stand.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        stand.hall?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        stand.type?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const openDenetimFormu = (stand) => {
        setSelectedStand(stand);
        setModalOpen(true);
    };

    const closeDenetimFormu = () => {
        setSelectedStand(null);
        setModalOpen(false);
    };

    const getDenetimColor = (formStatus, sentFormId) => {
        if (!sentFormId) {
            sentFormId = 4; // default to red color for unsent form
        }
        if (!formStatus || Object.keys(formStatus).length === 0) {
            return 'success'; // grey color for empty formStatus
        }
        const formContents = formStatus[sentFormId];

        if (formContents && formContents.answers && Object.keys(formContents.answers).length > 0) {
            let answersExist = formContents.answers;
            let uygunsuzlukCount = answersExist[2] ? answersExist[2]:0;
            let gerekYokCount = answersExist[0] ? answersExist[0]:0;
            let dofCount = answersExist[1] ? answersExist[1]:0;

            if (uygunsuzlukCount > 0) {
                return 'primary'; // red color if there's any "uygunsuzluk"
            }else if((gerekYokCount+dofCount) === formCount ){
                return 'secondary';
            }
            return 'warning'; // orange color if answers exist
        }

        return 'success'; // default to grey
    };

    return (
        <React.Fragment>
            <UiContent />
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("isgDenetim.isg")} pageTitle={t("isgDenetim.home")} />
                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title mb-4">{t("isgDenetim.standListesi")}</h4>
                                    <FormGroup className="mb-3">
                                        <Label for="searchInput">{t("common:ara")}</Label>
                                        <Input
                                            id="searchInput"
                                            type="text"
                                            value={searchTerm}
                                            onChange={handleSearch}
                                            placeholder={t("isgDenetim.standAdiFirmaAdiVeya")}
                                        />
                                    </FormGroup>
                                    {loading ? (
                                        <p>{t("common:yukleniyor")}</p>
                                    ) : stands.length === 0 ? (
                                        <p>{t("isgDenetim.hicStandBulunamadi")}</p>
                                    ) : (
                                        <Table className="table align-middle" style={tableStyles.table}>
                                            <thead>
                                                <tr>
                                                    <th>{t("isgDenetim.standAdi")}</th>
                                                    <th>{t("isgDenetim.firmaAdi")}</th>
                                                    <th>{t("isgDenetim.salon")}</th>
                                                    <th>{t("isgDenetim.islem")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredStands.map((stand) => (
                                                    <tr key={stand.stand_id}>
                                                        <td style={tableStyles.cell}>{stand.stand_name}</td>
                                                        <td style={tableStyles.cell}>
                                                            <div style={{ overflow: "hidden" }}>{stand.name}</div>
                                                        </td>
                                                        <td style={tableStyles.cell}>{stand.hall}</td>
                                                        <td style={tableStyles.cell}>
                                                            <Button color={getDenetimColor(stand.formStatus)} onClick={() => openDenetimFormu(stand)}>
                                                                {t("isgDenetim.denetimFormu")}
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal isOpen={modalOpen} toggle={closeDenetimFormu} size="lg">
                <ModalHeader toggle={closeDenetimFormu}>{t("isgDenetim.denetimFormu")}</ModalHeader>
                <ModalBody>
                    {selectedStand && (
                        <DenetimFormu 
                            formId={4} // You might want to dynamically set this
                            standId={selectedStand.stand_id}
                            selectedData={selectedStand}
                            activeFairId={activeFairId}
                            onClose={closeDenetimFormu}
                        />
                    )}
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default Denetim;
